import { sociedadApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'SOCIEDAD',
    api: sociedadApi,
    relUrl: id,
  });

export const getAll = getListDataAction({
  dataName: 'SOCIEDAD',
  api: sociedadApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'SOCIEDAD',
    api: sociedadApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'SOCIEDAD',
    api: sociedadApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'SOCIEDAD',
  api: sociedadApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'SOCIEDAD',
    api: sociedadApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('SOCIEDAD');
export const setDeletedPending = createListDataDeletedPending('SOCIEDAD');
